import React from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import PremiumHeader from "components/PremiumLanding/PremiumHeader";
import PremiumFooter from "components/PremiumLanding/PremiumFooter";
import "components/PremiumLanding/PremiumLanding.css";

export default function TermCondition() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings) || {};

  return (
    <div className="premium-landing premium-public-page" dir={isRTL ? "rtl" : "ltr"}>
      <Helmet>
        <title>{t("term_condition")} | Garahex</title>
        <meta name="description" content={t("term_condition_para1")} />
      </Helmet>
      <a className="pl-skip-link" href="#pl-main-content">Skip to content</a>
      <PremiumHeader isLoggedIn={Boolean(auth && auth.profile && auth.profile.uid)} />

      <main id="pl-main-content" className="pl-public-main">
        <section className="pl-public-hero pl-legal-hero">
          <div className="pl-public-hero__glow" aria-hidden="true" />
          <div className="pl-container pl-public-hero__inner">
            <div className="pl-public-hero__copy pl-reveal is-visible">
              <p className="pl-eyebrow pl-eyebrow--light">LEGAL</p>
              <h1>{t("term_condition")}</h1>
            </div>
            <div className="pl-public-hero__panel" aria-hidden="true">
              <span><GavelRoundedIcon /></span>
              <strong>GARAHEX</strong>
            </div>
          </div>
        </section>

        <section className="pl-public-section pl-legal-section">
          <div className="pl-container">
            <article className="pl-legal-document">
              <h2>{t("term_condition")}</h2>
              <p>{t("term_condition_para1")}</p>

              <p><strong>{t("term_condition_heading1")}</strong></p>
              <p>{t("term_condition_para2")}</p>

              <p><strong>{t("term_condition_heading2")}</strong></p>
              <p>{t("term_condition_para3")}</p>

              <p><strong>{t("term_condition_heading3")}</strong></p>
              <p>{t("term_condition_para4")}</p>

              <p><strong>{t("term_condition_heading4")}</strong></p>
              <p>{t("term_condition_para5")}</p>

              <p><strong>{t("term_condition_heading5")}</strong></p>
              <p>{t("term_condition_para6")}</p>

              <p><strong>{t("term_condition_heading6")}</strong></p>
              <p>{t("term_condition_para7")}</p>

              <p><strong>{t("term_condition_heading7")}</strong></p>
              <p>{t("term_condition_para8")}</p>

              <p><strong>{t("term_condition_heading8")}</strong></p>
              <p>{t("term_condition_para9")}</p>

              <p><strong>{t("term_condition_heading9")}</strong></p>
              <p>{t("term_condition_para10")}</p>

              <p><strong>{t("term_condition_heading10")}</strong></p>
              <p>{t("term_condition_para11")}</p>

              <p><strong>{t("term_condition_heading11")}</strong></p>
              <p>{t("term_condition_para12")}</p>

              <p><strong>{t("term_condition_heading12")}</strong></p>
              <p>{t("term_condition_para13")}</p>

              <p>
                {t("term_condition_para14")}{" "}
                {settings && settings.contact_email ? (
                  <a href={`mailto:${settings.contact_email}`}><strong>{settings.contact_email}</strong></a>
                ) : null}
              </p>
            </article>
          </div>
        </section>
      </main>

      <PremiumFooter settings={settings} />
    </div>
  );
}
